import {
  Avatar,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { animateScroll, Link } from "react-scroll";

const pages = [
  { name: "Home", link: "/" },
  { name: "About", link: "about" },
  { name: "Skills", link: "skills" },
  { name: "Projects", link: "projects" },
  { name: "Contact", link: "contact" },
  { name: "Resume", link: "bt" },
];
const DrawerComp = ({ setValue }) => {
  const [openDrawer, setDrawer] = useState(false);
  const hanHome = () => {
    setValue(0);
    animateScroll.scrollToTop();
  };
  return (
    <React.Fragment>
      <Drawer open={openDrawer} onClose={() => setDrawer(false)}>
        <a href="/">
          <Avatar
            src="./logo1.jpg"
            sx={{ margin: "auto", marginTop: "10px" }}
          />
        </a>
        <List>
          {pages.map((elem, index) =>
            elem.link !== "bt" ? (
              <Link
                key={index}
                activeClass="active"
                to={elem.link}
                onClick={() => {
                  elem.link === "/" ? hanHome() : setValue(index);
                }}
                spy={true}
                smooth={true}
              >
                <ListItemButton key={index} onClick={() => setDrawer(false)}>
                  <ListItemIcon>
                    <ListItemText>{elem.name}</ListItemText>
                  </ListItemIcon>
                </ListItemButton>
              </Link>
            ) : (
              <a
                href="https://drive.google.com/file/d/1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                key={index}
                style={{ textDecoration: "none", color: "#000000DE" }}
              >
                {" "}
                <ListItemButton key={index} onClick={() => setDrawer(false)}>
                  <ListItemIcon>
                    <ListItemText>{elem.name}</ListItemText>
                  </ListItemIcon>
                </ListItemButton>
              </a>
            )
          )}
        </List>
      </Drawer>
      <IconButton sx={{ color: "white", marginLeft: "auto" }}>
        <MenuIcon onClick={() => setDrawer(!openDrawer)} />
      </IconButton>
    </React.Fragment>
  );
};

export default DrawerComp;
